const parseNumberFromSizeVar = (sizeVar) => {
    return Number.parseFloat(sizeVar.match(/[-+]?\d*\.?\d+/));
};
const parseUnitFromSizeVar = (sizeVar) => {
    return sizeVar.match(/[^0-9]+/);
};
const divideBy = (base, divider) => {
    return `${parseNumberFromSizeVar(base) / divider}${parseUnitFromSizeVar(base)}`;
};

const multiplyBy = (base, multiplier) => {
    return `${parseNumberFromSizeVar(base) * multiplier}${parseUnitFromSizeVar(base)}`;
};

const getSpacing = (value, directions = 'all', paddingOrMargin) => {
    switch (directions) {
        case 'all':
            return {
                [paddingOrMargin]: value
            };
        case 'x': {
            return {
                [`${paddingOrMargin}Right`]: value,
                [`${paddingOrMargin}Left`]: value
            };
        }
        case 'y': {
            return {
                [`${paddingOrMargin}Top`]: value,
                [`${paddingOrMargin}Bottom`]: value
            };
        }
        case 't': {
            return {
                [`${paddingOrMargin}Top`]: value
            };
        }
        case 'r': {
            return {
                [`${paddingOrMargin}Right`]: value
            };
        }
        case 'b': {
            return {
                [`${paddingOrMargin}Bottom`]: value
            };
        }
        case 'l': {
            return {
                [`${paddingOrMargin}Left`]: value
            };
        }
        default:
            return {};
    }
};

export { divideBy, multiplyBy, getSpacing };
